import { combineReducers } from 'redux';
import GetLodgingRequest from 'store/reducers/lodgingRequest/get';
import ViewLodgingRequest from 'store/reducers/lodgingRequest/view';
import PreferredRoommates from 'store/reducers/lodgingRequest/preferredRoommates';
import AllPreferredRoommates from 'store/reducers/lodgingRequest/allPreferredRoommates';
import CancelLodgingRequest from 'store/reducers/lodgingRequest/cancel';
import ReopenLodgingRequest from 'store/reducers/lodgingRequest/reopen';
import EditLodgingRequest from 'store/reducers/lodgingRequest/edit';
import GetGuestsForFilter from 'store/reducers/lodgingRequest/getGuestsForFilter';
import GetLodgingRequestsCount from 'store/reducers/lodgingRequest/get-count';
import GetLocationData from 'store/reducers/lodgingRequest/getLocationData';
import GetFormData from 'store/reducers/lodgingRequest/getFormData';
import AddByManagerData from 'store/reducers/lodgingRequest/addByManager';
import exportExcel from 'store/reducers/lodgingRequest/exportExcel';
import checkIfExists from 'store/reducers/lodgingRequest/checkIfExists';
import readRequestsFilters from 'store/reducers/lodgingRequest/readRequestsFilters';
import requestTableFilters from 'store/reducers/lodgingRequest/requestTableFilters';
import cloneLodgingRequest from 'store/reducers/lodgingRequest/clone';
import editLodgingRequestDates from 'store/reducers/lodgingRequest/edit-dates';
import getActivityLogs from 'store/reducers/lodgingRequest/get-activity-logs';
import getReadyForAssignmentData from 'store/reducers/lodgingRequest/get-ready-for-assignment-data';
import getAllCount from 'store/reducers/lodgingRequest/get-all-count';
import tableColumns from 'store/reducers/lodgingRequest/request-table-columns';
import requestsByClientFilters from 'store/reducers/lodgingRequest/get-requests-by-client-filters';
import requestsByClient from 'store/reducers/lodgingRequest/get-requests-by-client';
import requestsByClientTableFilters from 'store/reducers/lodgingRequest/requests-by-client-table-filters';
import clientsForFilter from 'store/reducers/lodgingRequest/get-clients-for-filter';
import locationsForFilter from 'store/reducers/lodgingRequest/get-locations-for-filter';
import massActions from 'store/reducers/lodgingRequest/get-mass-actions';
import selectedForMassBookingData from 'store/reducers/lodgingRequest/selected-for-mass-booking';
import getSplitFormData from 'store/reducers/lodgingRequest/get-split-form-data';
import getBookingsByReservationId from './get-bookings-by-reservations';
import getAllBookings from 'store/reducers/lodgingRequest/get-all-bookings';
import getReportExcel from 'store/reducers/lodgingRequest/getReportExcel';

export default combineReducers({
  get: GetLodgingRequest,
  getCount: GetLodgingRequestsCount,
  view: ViewLodgingRequest,
  edit: EditLodgingRequest,
  cancel: CancelLodgingRequest,
  reopen: ReopenLodgingRequest,
  preferredRoommates: PreferredRoommates,
  allPreferredRoommates: AllPreferredRoommates,
  guestsForFilter: GetGuestsForFilter,
  getLocationData: GetLocationData,
  getFormData: GetFormData,
  addByManager: AddByManagerData,
  exportExcel,
  checkIfExists,
  readRequestsFilters,
  requestTableFilters,
  cloneLodgingRequest,
  editLodgingRequestDates,
  getActivityLogs,
  getReadyForAssignmentData,
  getAllCount,
  tableColumns,
  requestsByClientFilters,
  requestsByClient,
  requestsByClientTableFilters,
  clientsForFilter,
  locationsForFilter,
  massActions,
  selectedForMassBookingData,
  getSplitFormData,
  getBookingsByReservationId,
  getAllBookings,
  getReportExcel,
});
